import { constructEnum } from '@/lib/enum';

export default constructEnum('ReviewFormFieldType', {
  REVIEW_RATING: 0,
  REVIEW_MESSAGE: 1,
  REVIEW_OPTION: 2
});
